
import { isUUID } from '@/utils'
import { Entry, UUID } from '@Protium/vue-ozone-utils'
import { defineComponent, PropType, onMounted, computed, ref, watch } from 'vue'
import { useStore } from 'vuex'

export type DataUri = string // TODO: create guard for data type in uri

export enum ImageScalingAxis {
  Horizontal = 'horizontal',
  Vertical = 'vertical',
  Both = 'cover',
  Cover = 'cover',
  Contain = 'contain',
  LongestAxis = 'longest-axis'
}

export enum ImageAspect {
  Square = 'square',
  Portrait = 'portrait',
  Landscape = 'landscape',
}

export default defineComponent({
  name: 'ScalingImage',
  props: {
    src: {
      type: [String, Object]
    },
    resolver: {
      type: Function
    },
    scale: {
      type: String as PropType<ImageScalingAxis>,
      default: ImageScalingAxis.Cover
    },
    shape: {
      type: String as PropType<ImageAspect>,
      default: ImageAspect.Square
    },
    baseWidth: {
      type: Number,
      default: 80
    },
    baseHeight: {
      type: Number,
      default: 80
    },
    ratio: {
      type: Number,
      default: 1.25
    },
    radius: {
      type: Number,
      default: 6
    },
    showZoom: {
      type: Boolean,
      default: false
    }
  },
  setup (props) {
    const $store = useStore()
    const $directr = $store.getters['Services/Directr']

    const loading = ref(false)
    const resolved = ref<Record<string, any> | DataUri | undefined>(props.src as (UUID | DataUri))

    const source = computed(() => {
      return loading.value ? props.src : resolved.value
    })

    function isValidSrc (data:DataUri) {
      return typeof data === 'string' && new RegExp('http').exec(data) // TODO regex...
    }

    async function checkResolution (value = resolved.value) {
      const entry = ((value || {}) as Entry)
      if (!isValidSrc(value as DataUri) && entry.sys || isUUID(value as UUID)) {
        const resolver = props.resolver || (id => $directr.get('id', id))
        const {items: [resolvedSource]} = await resolver(isUUID(value as UUID) ? value : entry.sys?.id)
        // console.log('resolvedSource', resolvedSource)
        resolved.value = resolvedSource?.file?.url || resolvedSource?.file
      }
    }

    onMounted(checkResolution)

    watch(() => props.src, (value: UUID | DataUri) => checkResolution(value))

    return {
      source,
      style: computed(() => {
        return {
          borderRadius: `${props.radius}px`,
          width: `${props.shape === ImageAspect.Landscape ? props.baseWidth * props.ratio : props.baseWidth}px`,
          height: `${props.shape === ImageAspect.Portrait ? props.baseHeight * props.ratio : props.baseHeight}px`,
          backgroundColor: 'transparent',
          backgroundImage: `url('${source.value}')`,
          backgroundSize: props.scale === ImageScalingAxis.Cover ? 'cover' : props.scale === ImageScalingAxis.Horizontal ? '100% auto' : 'auto 100%',
          backgroundPosition: '50% 50%'
        }
      }),
      zoomStyle: computed(() => {
        return {
          borderRadius: `${props.radius}px`,
          backgroundColor: 'white',
          backgroundImage: `url('${source.value}')`,
          // backgroundSize: props.scale === ImageScalingAxis.Cover ? 'cover' : props.scale === ImageScalingAxis.Horizontal ? '100% auto' : 'auto 100%',
          backgroundSize: 'contain',
          backgroundRepeat: 'no-repeat',
          backgroundPosition: '50% 50%'
        }
      })
    }
  },
})
